export { default as featuredProjects } from './featuredProjects'
export { default as ourProcess } from './ourProcess'
export { default as socials } from './socials'
export { default as team } from './team'
export { default as service } from './service'
